import dynamic from "next/dynamic";

export const MiniHero = dynamic(() => import("./component"));
